import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
export default {
  formatACN: function formatACN(gn) {
    var txt = gn.replaceAll(' ', '');
    // eslint-disable-next-line
    var txta = txt.match(new RegExp('.{1,' + 3 + '}', 'g'));
    var ntxt = txta[0];
    if (txta[1]) {
      ntxt += " ".concat(txta[1]);
    }
    if (txta[2]) {
      ntxt += " ".concat(txta[2]);
    }
    return ntxt;
  },
  replaceAll: function replaceAll(search, replacement, val) {
    if (!val) {
      return val;
    }
    while (val.indexOf(search) > -1) {
      val = val.replace(search, replacement);
    }
    return val;
  }
};